import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { soundManager } from 'soundmanager2';

// https://github.com/seiyria/bootstrap-slider
// https://github.com/brownieboy/react-bootstrap-slider
import ReactBootstrapSlider from 'react-bootstrap-slider';
import * as remixActions from './actions/remix-actions';
import * as samActions from './actions/sam-actions';

class AudioPlayer extends Component {

  constructor(props){
    super(props);
    this.state = {
      playing: false,
      volume: 75,
      stream_url: null
    };
  }

  loadSound(){
    const self = this;
    self.stream = soundManager.createSound({
      autoLoad: true,
      autoPlay: self.state.playing,
      volume: self.state.volume,
      stream: true,
      url: self.state.stream_url,
      onerror: function(errorCode, description){
        console.log(this.id + ' failed?', errorCode, description);
        this.destruct();
        if(self.props.remix){
          self.props.remixActions.getStreamUrl();
        }else{
          self.props.samActions.getStreamUrl();
        }
      },
      onfinish: function(){
        this.destruct();
        if(self.props.remix){
          self.props.remixActions.getStreamUrl();
        }else{
          self.props.samActions.getStreamUrl();
        }
      }
    });
  }

  componentWillReceiveProps(nextProps){
    const self = this;
    this.setState({ stream_url: nextProps.stream_url}, function(){
      soundManager.onready(function(){
        self.loadSound();
      });
    });
  }

  componentWillMount(){
    soundManager.setup({
      debugMode: (process.env.NODE_ENV !== 'production'),
    });
  }

  playPause(){
    if(!this.state.playing){
      this.stream.play();
      this.setState({ playing: true });
    }else{
      this.stream.pause();
      this.setState({ playing: false });

      // destroy the player if its a sam
      if(!this.props.remix){
        this.stream.destruct();
      }
    }
  }

  changeVolume(e){
    this.setState({
      volume: e.target.value
    });

    this.stream.setVolume(e.target.value);
  }

  render(){
    return (
      <div className="AudioPlayer">
        <div className="Controls">
          <a className="PlayPause" onClick={ this.playPause.bind(this) } id="play-pause">
              <i className={ !this.state.playing ? "fa fa-play fa-4x" : "fa fa-pause fa-4x" }>
            </i>
          </a>
          <div className="Volume">
            <ReactBootstrapSlider
              value={ this.state.volume }
              change={ this.changeVolume.bind(this) }
              step={ 1 }
              max={ 100 }
              min={ 0 }
              tooltip="hide"
              orientation="horizontal" />
          </div>
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  remix: PropTypes.bool.isRequired,
  stream_url: PropTypes.node
};

function mapDispatchToProps(dispatch){
  return {
    remixActions: bindActionCreators(remixActions, dispatch),
    samActions: bindActionCreators(samActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(AudioPlayer);



// WEBPACK FOOTER //
// ./src/AudioPlayer.js